import script from "./dummyData8.vue?vue&type=script&lang=js"
export * from "./dummyData8.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__